export const getValidBars = (bars: number) => {
	if (bars > 0 && bars <= 16) {
		return bars
	} else {
		return Math.max(1, Math.min(16, bars))
	}
}
